const isClient = typeof window !== "undefined";

// Base URLs and app configuration
export const apiOrigin = process.env.GATSBY_API_ORIGIN;
export const apiBaseUrl = process.env.GATSBY_API_BASE_URL;
export const appBaseUrl = process.env.GATSBY_APP_BASE_URL;
export const appName = process.env.GATSBY_APP_NAME;
export const userDataKey = process.env.GATSBY_USER_DATA_KEY;

export const appOrigin = process.env.GATSBY_APP_ORIGIN;

export const paystackPublicKey = process.env.GATSBY_PAYSTACK_PUBLIC_KEY;
export const paystackLocalEmailKey = process.env.GATSBY_PAYSTACK_LOCAL_EMAIL_KEY;
export const paystackLocalReference = process.env.GATSBY_PAYSTACK_LOCAL_REFERENCE;
export const paystackLocalNotification = process.env.GATSBY_PAYSTACK_LOCAL_NOTIFICATION;

export const phoneNumber = process.env.PHONE_NUMBER;
export const phoneNumberReadable = process.env.PHONE_NUMBER_READABLE;
export const phoneNumberNoPlus = process.env.PHONE_NUMBER_NO_PLUS;
export const localPhoneNumber = process.env.LOCAL_PHONE_NUMBER;
export const localPhoneNumberReadable = process.env.LOCAL_PHONE_NUMBER_READABLE;

export const gtagId = process.env.GATSBY_GTAG_ID;
export const gtmId = process.env.GATSBY_GTM_ID;
export const fbPixelId = process.env.GATSBY_FACEBOOK_PIXEL_ID;

if (
    isClient &&
    (!apiOrigin ||
        !apiBaseUrl ||
        !appBaseUrl ||
        !appName ||
        !userDataKey ||
        !appOrigin ||
        !paystackPublicKey ||
        !paystackLocalEmailKey ||
        !paystackLocalReference ||
        !paystackLocalNotification ||
        !gtagId ||
        !gtmId ||
        !fbPixelId)
) {
    throw new Error("Missing environment variables");
}
